/* eslint-disable import/prefer-default-export */

/**
 * Detect if current browser is a mobile device or not
 * @returns boolean
 */
export function isMobile() {
	return /Mobi|Android/i.test(navigator.userAgent);
}
